<template>
  <div v-if="notify.uuid" class="notify_panel after_border" @click="gotoDetail">
    <div class="in_panel" :class="{dot: !notify.is_read}">
      <img :src="logoImg" class="headimg">
      <div class="body">
        <div class="title">{{ title }}</div>
        <div class="info">{{ notify.content }}</div>
      </div>
      <div class="time">{{ notify.add_time_format2 }}</div>
    </div>
  </div>
</template>

<script>
import logoImg from '@/assets/images/logo_small.jpg'

export default {
  name: 'NotifyPanel',
  components: {
  },
  props: {
    // 消息类型 1系统通知 2提醒
    type: {
      type: Number,
      default: 1
    },
    notify: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      title: '',
      logoImg: logoImg
    }
  },
  created () {
    if (this.type === 1) {
      this.title = '系统消息'
    } else if (this.type === 2) {
      this.title = '提醒'
    }
  },
  methods: {
    gotoDetail () {
      this.$router.push('/notification/detail?type=' + this.type)
    }
  }
}
</script>

<style scoped lang="scss">
.in_panel {
  height: 110px;
  padding: 15px 5px 15px 0;
  display: flex;
  justify-content: space-between;
  // align-items: center;
  position: relative;
  &.dot::after{
    bottom: 35px;
    right: 30px;
    width: 8PX;
    height: 8PX;
    content: ' ';
    position: absolute;
    border-radius: 100%;
    background-color: #f44;
  }
  .headimg {
    margin-top: 10px;
    width: 90px;
    height: 90px;
    border-radius: 50%;
    margin-left: 20px;
  }
  .body {
    width: 470px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    .title {
      font-size: 29px;
      color: #323233;
      font-weight: bold;
    }
    .info {
      font-size: 26px;
      color: #666;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .time {
    font-size: 24px;
    color: #666;
    margin-right: 15px;
    padding-top: 8px;
  }
}
</style>
